<template>
<div>
    <div class="kada-home" :class="showinpout===true? 'bulr':''">
        <div id="tab1" class="home-content">
            <div class="video">
                <video :src="home.videoUrl" muted="" autoplay loop poster="https://static.ws.126.net/163/f2e/news/chinese_answer/images/banner_bg.jpg"></video>
            </div>
               <div class="imgBoxIndex">
                    <img src="@/assets/img/zjst.png" alt="">
                     <p style="font-size:32px;line-height:70px;letter-spacing: 1px;">Beautiful China, Picturesque Zhejiang</p>
                    <p style="margin-top:30px;">- 对外文化交流和旅游推广资源数据库专题 -</p>
                    <p style="font-size:16px;margin-top:12px;">External Cultural Exchange and Tourism Promotion Resource Database</p>
                </div>
            <div class="kada-container">
                <div class="video-text">
                    <div class="top-logo">
                        <img src="@/assets/img/logo.png" alt=""/>
                    </div>
                    <div class="search" @click="seaching">
                        <img src="@/assets/img/search.png" alt=""/>
                        <p>搜索</p>
                    </div>
                    <!-- <div class="center-logo">
                        <img src="@/assets/img/logo.png" alt=""/>
                    </div> -->
                    <div class="json-action">
                        <lottie
                        :options="defaultOptions"
                        @animCreated="handleAnimation"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div id="tab2" class="home-content" style="display: block;">
            <div class="bg">
                <div class="kada-container">
                    <div class="top">
                        <div class="title">
                            <span style="display:bolck">对外文化交流和旅游推广资源数据库专题</span>
                             <p style="font-size:12px;margin-top:12px;">External Cultural Exchange and Tourism Promotion Resource Database</p>
                        </div>
                        <div class="logo">
                            <img src="@/assets/img/logo.png" alt=""/>
                        </div>
                    </div>
                    <div class="brief kada-clearfix">
                        <div class="elem">
                            <img src="@/assets/img/img_elex.png" alt=""/>
                        </div>
                        <div class="left">
                            <img src="@/assets/img/img_title1.png" alt=""/>
                        </div>
                        <div class="right">
                            <div v-html="home.brief"></div>
                            <!-- <p class="zh" v-html="home.brief">为稳步推进浙江省文化和旅游“金名片”海外推广工程的实施，浙江省文化和旅游厅建立并完善全省对外文化交流和旅游推广资源数据库。在中国共产党成立100周年之际，围绕我省数字化改革重点工作，特推出百项对外文化交流和旅游推广数字资源，为全省文化和旅游“走出去”“请进来”工作搭建推广展示平台，助力提升“诗画浙江”国际影响力，积极打造“世界看浙江”闪亮窗口。</p> -->
                            <!-- <p class="eng">In order to steadily promote the implementation of the "Gold Business Card" overseas promotion project of Zhejiang Culture and Tourism, Zhejiang Provincial Department of Culture and Tourism has created and improved the provincial database of external culture exchange and tourism promotion resources. On the occasion of the 100th anniversary of the founding of the Communist Party of China, one hundred of digital resources of external culture exchange and tourism promotion have been compiled following the key work of digital reform in Zhejiang to build a promotion and display platform for the "going out" and "coming in" of culture and tourism, enhancing the international influence of "Picturesque Zhejiang" and creating a window for the world to see Zhejiang.</p> -->
                        </div>
                    </div>
                    <div class="line">
                        <img src="@/assets/img/img_line3.png" alt=""/>
                    </div>
                    <div class="content-list kada-clearfix">
                        <div class="left">
                            <div class="list-title">
                                <p class="zh">{{left.menuCateName}}</p>
                                <p class="eng">{{left.subName}}</p>
                                <img src="@/assets/img/img_line1.png" alt=""/>
                            </div>
                            <ul class="list-ul-three kada-clearfix">
                                <li style="width:226px;">
                                    <div class="item" @click.stop="toPath(menu.id)" v-show="index <= 2" v-for="(menu,index) in left.childMenus" :key='"left"+index'>
                                        <p class="num">{{getIndex(index+1)}}</p>
                                        <div class="elem"></div>
                                        <div class="r-title">
                                            <p class="top-zh"><span>{{menu.menuCateName}}</span></p>
                                            <p class="bottom-eng">{{menu.subName}}</p>
                                        </div>
                                    </div>
                                </li>
                                <li style="width:323px;">
                                    <div class="item" @click.stop="toPath(menu.id)" v-show="index > 2 && index <= 5" v-for="(menu,index) in left.childMenus" :key='"left"+index'>
                                        <p class="num">{{getIndex(index+1)}}</p>
                                        <div class="elem"></div>
                                        <div class="r-title">
                                            <p class="top-zh"><span>{{menu.menuCateName}}</span></p>
                                            <p class="bottom-eng">{{menu.subName}}</p>
                                        </div>
                                    </div>
                                </li>
                                <li style="width:310px;">
                                    <div class="item" @click.stop="toPath(menu.id)" v-show="index > 5" v-for="(menu,index) in left.childMenus" :key='"left"+index'>
                                        <p class="num">{{getIndex(index+1)}}</p>
                                        <div class="elem"></div>
                                        <div class="r-title">
                                            <p class="top-zh"><span>{{menu.menuCateName}}</span></p>
                                            <p class="bottom-eng">{{menu.subName}}</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="right">
                            <div class="list-title">
                                <p class="zh">{{right.menuCateName}}</p>
                                <p class="eng">{{right.subName}}</p>
                                <img src="@/assets/img/img_line2.png" alt=""/>
                            </div>
                            <ul class="list-ul-one kada-clearfix">
                                <li @click.stop="toPath(menu.id)" v-for="(menu,index) in right.childMenus" :key='"right"+index'>
                                    <p class="num">{{getIndex(left.childMenus.length+index+1)}}</p>
                                    <div class="elem"></div>
                                    <div class="r-title">
                                        <p class="top-zh"><span>{{menu.menuCateName}}</span></p>
                                        <p class="bottom-eng">{{menu.subName}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      <div class="search-input" v-if="showinpout">
          <div class="kada-container">
              <img @click="searchTitile" class="close" src="@/assets/img/close.png" alt=""/>
              <div class="input">
                  <input type="text" placeholder="请输入关键字" v-model.trim="searchKey" @keyup.enter="searchAll">
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import lottie from 'vue-lottie'
import dys from '@/assets/json/dys.json'
export default {
  components: {
    lottie
  },
  data() {
    return {
      defaultOptions: {
        animationData: dys,
        loop: true,
        autoplay: true,
        name: 'weatherVisit'
      },
      searchKey: '',
      showinpout: false,
      home: {},
      left: {},
      right: {},
      MouseScroll: null
    }
  },
  methods: {
    searchTitile() {
      this.showinpout = false
      this.searchKey = ''
    },
    handleAnimation(anim) {
      // console.log('handleAnimation')
      this.anim = anim
    //   anim.stop()
    },
    seaching() {
      this.showinpout = true
    },
    searchAll() {
      if (this.searchKey) {
        this.$router.push({
          name: 'search',
          params: { searchKey: this.searchKey }
        })
      }
    },
    getHome() {
      const _this = this
      this.$apis.ConfigsOne({ id: 1 }).then(res => {
        _this.home = res.data.data.list[0]
      })
    },
    getIndex(index) {
      if (index < 10) {
        return '0' + index
      } else {
        return index
      }
    },
    getMenus() {
      const _this = this
      const params = {}
      this.$apis.getMenusList(params).then(res => {
        if (res.data.data.list.length > 0) {
          var menuList = res.data.data.list
          _this.left = menuList[0]
          _this.right = menuList[1]
        }
      })
    },
    toPath(id) {
      this.$router.push({
        name: 'topic_list',
        params: { id: id }
      })
    },
    // 判断网页是否向上向下滚动
    mouse_scroll() {
      // 兼容完整处理 通过浏览器判断
      var browser = window.navigator.userAgent
        .toLowerCase()
        .indexOf('firefox')

      var totalheight = document.getElementsByClassName('kada-home')[0].clientHeight
      if (browser !== -1) {
        // 处理火狐滚轮事件
        document.addEventListener('DOMMouseScroll', function(ev) {
          var oEvent = ev || event
          // 上下滚轮动作判断
          if (oEvent.detail < 0) {
            // 向上滚动
            // ### 向上
            //  window.location.href = window.location.origin + window.location.pathname + '#tab' + 1
            if (window.location.href.indexOf('index') > -1) {
              document.getElementById('tab2').style.display = 'none'
              document.getElementById('tab1').style.display = 'block'
              window.scrollTo(0, 0)
            }
          } else {
            // ### 向下
            // window.scrollTo(0,totalheight/2)
            if (window.location.href.indexOf('index') > -1) {
              document.getElementById('tab1').style.display = 'none'
              document.getElementById('tab2').style.display = 'block'
              window.scrollTo(0, 0)
            }
            // window.location.href = window.location.origin + window.location.pathname + '#tab' + 2
          }
        })
      } else {
        // 其他浏览器
        document.onmousewheel = function(ev) {
          var oEvent = ev || event
          // 上下滚轮动作判断
          console.log(totalheight)
          if (oEvent.wheelDelta > 0) {
            // ### 向上
            // window.location.href = window.location.origin + window.location.pathname + '#tab' + 1
            if (window.location.href.indexOf('index') > -1) {
              document.getElementById('tab2').style.display = 'none'
              document.getElementById('tab1').style.display = 'block'
              window.scrollTo(0, 0)
            }
          } else {
         	  // ### 向下
            // window.scrollTo(0,totalheight/2)
            if (window.location.href.indexOf('index') > -1) {
              document.getElementById('tab1').style.display = 'none'
              document.getElementById('tab2').style.display = 'block'
              window.scrollTo(0, 0)
            }
            //  window.location.href = window.location.origin + window.location.pathname + '#tab' + 2
          }
        }
      }
    }
  },
  created() {
    this.getHome()
    this.getMenus()
  },
  mounted() {
    //   this.mouse_scroll()
  },
  beforeDestroy() {
    //   document.removeEventListener("DOMMouseScroll", this.MouseScroll, true);
  }
}
</script>
<style lang="scss" scope>
.bulr{
 -webkit-filter: blur(24px); /* Chrome, Opera */
-moz-filter: blur(24px);
-ms-filter: blur(24px);
filter: blur(24px);
}
 .imgBoxIndex{position: absolute;top: 336px;z-index: 99;text-align: center;
     left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);}
.imgBoxIndex>img{width: 1330px;height:139px; }
.imgBoxIndex>p{color: #fff;font-size: 32px;line-height: 30px;letter-spacing:40;font-family: zktqkt;}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue